module.exports = "/_next/static/images/btn-cancel-c5d81ac4.png";